import { TabAclrrModel } from "./tabAclrr.model";

export class InsertAclrrINModel {
    tabAclrr: TabAclrrModel
}